import { useCallback, useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Formik } from 'formik';
import FormFields from '../Form'
import Sidebar from "../../../../../components/Sidebar";
import { initialValues, schema } from '../../../../../constants/forms/category/edit'
import { updateCategory } from '../../../../../store/actions/category'
import { CategoryDto, EditCategoryOutDto } from '../../../../../types/category';
import { Group } from '../../../../../types';
import { ConnectedFocusError } from '../../../../../components/ConnectedFocusError';

const unitsInDays = {
  day: 1,
  week: 7,
  month: 30,
  year: 365,
};

const convertToDays = (number, units) => {
  const key = units.toLowerCase().trim();

  if (!unitsInDays.hasOwnProperty(key)) {
    throw new Error(`Unidad no reconocida: ${units}`);
  }

  return number * unitsInDays[key];
}

const convertDaysToUnit = (days) => {
  if (days % unitsInDays.year === 0) {
    return { value: days / unitsInDays.year, unit: 'year' };
  } else if (days % unitsInDays.month === 0) {
    return { value: days / unitsInDays.month, unit: 'month' };
  } else if (days % unitsInDays.week === 0) {
    return { value: days / unitsInDays.week, unit: 'week' };
  } else {
    return { value: days, unit: 'day' };
  }
};


interface ComponentProps {
  group: Group
  groupStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
  updatedCategory: CategoryDto;
  updatedCategoryStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
  category?: CategoryDto
  onClose: any
  isVisible: boolean
}

const Component = ({
  group,
  updatedCategoryStates,
  category,
  onClose,
  isVisible
}: ComponentProps) => {
  const dispatch = useDispatch();
  const [formSubmmited, setFormSubmmited] = useState(false);

  const onSubmit = useCallback(({ values, actions }: { values: any, actions }) => {
    if (!category?.id) {
      console.error('Category ID undefined')
      return
    }

    const is_unlockable = values?.is_unlockable.includes('true');
    const days = is_unlockable ? convertToDays(values?.number_to_unlock, values?.unit_to_unlock) : null;

    const payload: EditCategoryOutDto = {
      id: category?.id,
      group_id: group?.id,
      name: values?.name,
      description: values?.description,
      is_unlockable,
      days_to_unlock: days,
      unlock_message: values?.unlock_message,
      grace_period_type: values?.grace_period_type,
      grace_period_in_days: values?.grace_period_in_days,
    };

    dispatch(updateCategory(payload));
  }, [category, group]);

  return <>
    <Sidebar
      position="right"
      visible={isVisible}
      closeType="close"
      onClose={() => {
        !!onClose && onClose();
      }}
      width="463px"
      title={
        <div style={{ padding: "0px 18px", display: "flex", flexDirection: 'column' }}>
          <span>Editar categoría</span>
          <span style={{ fontSize: 14, lineHeight: 1, fontWeight: "normal", color: "#717171" }}>Edita tu categoría.</span>
        </div>
      }
      options={{
        style: { padding: "93px 0px 0px" },
        titleStyle: {
          top: 20,
        }
      }}
    >
      <Formik
        initialValues={{
          ...initialValues,
          name: category?.name || initialValues?.name,
          description: category?.description || initialValues?.description,
          is_unlockable: category?.is_unlockable ? ['true'] : [],
          number_to_unlock: category?.is_unlockable ? convertDaysToUnit(category?.days_to_unlock)?.value : null,
          unit_to_unlock: category?.is_unlockable ? convertDaysToUnit(category?.days_to_unlock)?.unit : null,
          //show_before_unlock: category?.is_unlockable ? category?.show_before_unlock || initialValues?.show_before_unlock : null,
          unlock_message: category?.is_unlockable ? category?.unlock_message : null,
          grace_period_type: category?.is_unlockable ? category?.grace_period_type : null,
          grace_period_in_days: category?.is_unlockable ? (category?.grace_period_type !== 'limited' ? null : (category?.grace_period_in_days || initialValues?.grace_period_in_days)) : null,
        }}
        onSubmit={(values, actions) => {
          if (onSubmit) onSubmit({ values, actions });
        }}
        validateOnChange={false}
        validateOnBlur={formSubmmited}
        validationSchema={schema}
      >
        {({
          handleSubmit,
          resetForm,
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          validateForm,
          setTouched,
          validateField
        }) => {
          return (
            <form
              className="theme-form"
              onSubmit={(event) => {
                setFormSubmmited(true);
                handleSubmit(event);
              }}
              id="update-category-form"
            >
              <ConnectedFocusError />
              <FormFields
                values={values}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                validateForm={validateForm}
                setTouched={setTouched}
                validateField={validateField}
                initialValues={initialValues}
                loading={updatedCategoryStates.loading}
                onClose={() => { onClose(false); resetForm() }}
                formId="update-category-form"
              />
            </form>
          );
        }}
      </Formik>
    </Sidebar>
  </>
}

const state = ({ groupStore, categoryStore }) => {
  const { data: categories, states: categoriesState } =
    categoryStore?.allCategories;
  const { data: group, states: groupStates } =
    groupStore.group;
  const { data: updatedCategory, states: updatedCategoryStates } = categoryStore.updateCategory;

  return {
    group,
    groupStates,
    categories,
    categoriesState,
    updatedCategory,
    updatedCategoryStates,
  };
};

export default connect(state)(Component);